import { IGoalsTableData } from 'PDF/components/GoalsTable/types';

export const getIsGoalsAndObjectivesTableEmpty = (goalsAndObjectivesTableData: IGoalsTableData) => {
  const { shortTerm, longTerm } = goalsAndObjectivesTableData.data;

  if (shortTerm.content.length === 0 && longTerm.content.length === 0) {
    return true;
  }

  if (shortTerm.content.length === 0 && longTerm.content.length > 0) {
    return longTerm.content.every((item) => item.every((subItem) => subItem === ''));
  }

  if (longTerm.content.length === 0 && shortTerm.content.length > 0) {
    return shortTerm.content.every((item) => item.every((subItem) => subItem === ''));
  }

  return (
    shortTerm.content.every((item) => item.every((subItem) => subItem === '')) ||
    longTerm.content.every((item) => item.every((subItem) => subItem === ''))
  );
};
